export const defaultAnimation = {
    startup: true,
    duration: 1000,
    easing: "#out"
};
export const defaultGraphWidth = "100%";
export const defaultGraphHeight = "400px";
export const getDefaultColumns = (seriesLabel) => {
    return [{ label: "days", type: "date" },
        { label: seriesLabel, type: "number" }];
};
export const defaultAxisTextStyle = {
    fontSize: 12,
    color: "#999",
    bold: false,
    italic: false
};
export const noValuesAxisTextStyle = {
    fontSize: 0,
    color: "#fff",
    bold: false,
    italic: false
};
export const defaultAxisTitleTextStyle = {
    fontSize: 12,
    color: "#999",
    bold: false,
    italic: false
};
export const defaulTitleTextStyle = {
    fontSize: 14,
    color: "#999",
    bold: false,
    italic: false
};
export class DefaultVAxis_Number {
    constructor(title, gridlineCount, showValues = true) {
        this.title = title;
        this.titleTextStyle = defaultAxisTitleTextStyle;
        this.minValue = 0;
        this.format = ""; // forces the vAxis values to be integers
        if (showValues) {
            this.textStyle = defaultAxisTextStyle;
        }
        else {
            this.textStyle = noValuesAxisTextStyle;
        }
        this.gridlines = { count: gridlineCount, color: "#e5e5e5" };
        this.baselineColor = "#bbb";
    }
}
export class DefaultHAxis_Time {
    constructor(title, ticks) {
        this.title = title;
        this.titleTextStyle = defaultAxisTitleTextStyle;
        this.minValue = null;
        this.format = "d MMM y";
        this.textStyle = defaultAxisTextStyle;
        this.gridlines = { count: null, color: "#f0f0f0" };
        this.baselineColor = "#bbb";
        this.format = "d MMM y";
        this.slantedText = false;
        this.minTextSpacing = 1;
        this.ticks = ticks;
    }
}
